import React from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { HelpCircle } from "lucide-react";

export const PageHeader = ({ title, description, legend, right, testId }) => (
  <div className="mb-5 flex flex-wrap items-end justify-between gap-3 border-b border-slate-800/70 pb-3" data-testid={testId || "page-header"}>
    <div className="min-w-0">
      <div className="flex items-center gap-2">
        <h1 className="font-display text-2xl font-bold uppercase tracking-wide text-white sm:text-3xl">{title}</h1>
        {legend && (
          <Popover>
            <PopoverTrigger asChild>
              <button data-testid="page-legend-btn" aria-label="What do these mean?"
                className="flex h-8 w-8 items-center justify-center rounded-full border border-slate-700 text-slate-400 transition-colors hover:border-cyan-500 hover:text-cyan-300">
                <HelpCircle className="h-4 w-4" />
              </button>
            </PopoverTrigger>
            <PopoverContent align="start" className="w-80 border-slate-700 bg-slate-950 p-3" data-testid="page-legend">
              <p className="mb-2 font-mono text-[10px] uppercase tracking-widest text-cyan-400">How to read this page</p>
              <ul className="space-y-1.5">
                {legend.map(([k, v]) => (
                  <li key={k} className="font-mono text-[11px] leading-snug text-slate-300"><span className="font-bold text-white">{k}</span> — {v}</li>
                ))}
              </ul>
            </PopoverContent>
          </Popover>
        )}
      </div>
      {description && <p className="mt-1 max-w-3xl text-sm text-slate-400" data-testid="page-description">{description}</p>}
    </div>
    {right}
  </div>
);

export default PageHeader;
